import { useRouter } from "next/router";
import { clearRouterPath } from "~/features/app/utils";
import { fragment } from "~/features/ui/link/utils";
import { useFragment, type FragmentType } from "~/gql/runtime";

export function useLinkActive(link?: FragmentType<typeof fragment>) {
  const _link = useFragment(fragment, link);
  const router = useRouter();

  if (!_link) {
    return;
  }

  if (clearRouterPath(router.asPath) === "/") {
    return false;
  }

  return _link.href?.endsWith(clearRouterPath(router.asPath));
}
